import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Store, select } from '@ngrx/store';

import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject, Subscription, forkJoin, fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

import { Router } from '@angular/router';
import { commonImages } from '@images/common-images';
import { contactImages } from '@images/contact-images';
import { ApiService } from '@services/api/api.service';
import { HistoryService } from '@services/api/history.service';
import { LeadsService } from '@services/api/leads.service';
import { ListingPropertiesService } from '@services/api/listing-properties.service';
import { SettingService } from '@services/api/setting.service';
import { SharedService } from '@services/api/shared.service';
import { StaffContactService } from '@services/api/staff-contact.service';
import { TagMangerService } from '@services/api/tag-manger.service';
import { UserService } from '@services/api/user.service';
import { WorkflowService } from '@services/api/workflow.service';
import { AuthService } from '@services/auth.service';
import { Crypto } from '@services/helpers/encryption-utils';
import { FormHelper } from '@services/helpers/form-helper';
import { LocalStorageService } from '@services/helpers/local-storage.service';
import { Utils } from '@services/helpers/utils';
import { LeadManagementService } from '@services/lm-service/lead-management.service';
import { MessageService } from '@services/util/message.service';
import { RemmiConfirmService } from '@common/remmi-confirm/remmi-confirm.service';
import { RootReducerState, getLoggedInUserStatus } from '@state-management/reducers';
import { ReduxService } from '@state-management/redux.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { environment } from 'src/environments/environment';
import { DashService } from '../../dash-board/dash.service';
import { tabsConfig } from './tabs.config';
import { ContactAlternativeRow, toAlternativePayload, toAlternativeRows } from '../contact-alternative-info/contact-alternative-info.model';
import { CalendarAPIService } from '@services/api/calendarAPI.service';

declare var $: any;

@Component({
  selector: 'app-edit-office-contact',
  templateUrl: './edit-office-contact.component.html',
  styleUrls: ['./edit-office-contact.component.scss'],
})
export class EditOfficeContactComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @ViewChild('ops') ops!: OverlayPanel;
  @ViewChild('chipsRef', { read: ElementRef }) chipsRef: ElementRef;
  @Input() contactDetails: any = null;
  @Input() tabIndex: any;
  @Input() renderTaskList: any;
  @Input() IsLeadSaved: Observable<boolean> = null;
  @Input() IsProjectSaved: Observable<boolean> = null;
  @Input() renderPropertyList: Observable<boolean> = null;
  @Input() contractList: Observable<any> = null;
  @Output() isPropertyOpen = new EventEmitter<boolean>();
  @Output() isContactClose = new EventEmitter<any>();
  @Output() emitterObject = new EventEmitter<any>();
  @Output() updatedContact = new EventEmitter<boolean>();

  teams: any;
  rightActiveIndex: number = 0;
  images = contactImages;
  common_images = commonImages;

  // Office contact table
  @ViewChild('searchKeyword', { static: true }) searchKeyword: ElementRef;

  // attaching property
  attached_properties: any[] = [];
  attached_listing: any[] = [];
  attached_contracts: any[] = [];
  attach_property: any;
  attach_listing: any;
  propertiesList: any;

  property_search_complete: boolean = false;
  email_modal: boolean = false;
  emailTo: string = '';
  emailFrom: string = 'remmi <noreply@remmi.com.au>';
  emailTempSelectedId: any = null;
  emailTempSelected: any = null;
  emailTemplates: any;
  emailSubject: string = '';
  emailBody: any = '';
  rPropActiveIndex: number = 1;

  ContactColumns = [
    {
      type: 'text',
      field: 'relation',
      column: 'Relation',
    },
    {
      type: 'text',
      field: 'full_name',
      column: 'Name',
    },
    {
      type: 'text',
      field: 'company_name',
      column: 'Company',
    },
    {
      type: 'text',
      field: 'mobile_no',
      column: 'Mobile',
    },
    {
      type: 'text',
      field: 'contact_type',
      column: 'Contact Type',
    },
    {
      type: 'text',
      field: 'telephone_no',
      column: 'Telephone',
    },
    {
      type: 'text',
      field: 'email',
      column: 'Email',
    },
  ];
  aus_phone = {
    code: '+61',
    flag: 'https://flagpedia.net/data/flags/mini/au.png',
    name: 'Australia',
  };
  selectedContact: any;

  // ---- External EOI link ---------------------------------------------------
  // Lets an agent send the buyer-facing EOI form straight from a contact.
  // A contact has no single project, so the dialog asks for one.

  showExternalEoiModal = false;

  get externalEoiContactId(): string | null {
    return this.selectedContact?._id || this.selected_Contact_Input_id || null;
  }

  get externalEoiContactName(): string {
    return this.selectedContact?.full_name || `${this.selectedContact?.first_name || ''} ${this.selectedContact?.last_name || ''}`.trim();
  }

  openExternalEoiModal(): void {
    this.showExternalEoiModal = true;
  }

  public userPermission = Crypto.decrypt(this.localStorageService.GetItem('_per'));
  public userRole = Crypto.decrypt(this.localStorageService.GetItem('role'));
  public userRoleId = Crypto.decrypt(this.localStorageService.GetItem('roleid'));
  public staffUsers: any[];
  public role_id: string = '';

  //  public bulkAction: FormGroup;
  public selectedRows = [];
  public SortBy: string = '';
  // rightBar
  logos = [];
  current_role_id: any;

  public Editor = ClassicEditor;
  ckEditorToolbar = {
    toolbar: {
      items: [
        'heading',
        '|',
        'fontfamily',
        'fontsize',
        'fontColor',
        'fontBackgroundColor',
        '|',
        'bold',
        'italic',
        'strikethrough',
        'subscript',
        'superscript',
        'code',
        '|',
        'link',
        'uploadImage',
        'blockQuote',
        'codeBlock',
        '|',
        'alignment',
        '|',
        'bulletedList',
        'numberedList',
        'todoList',
        'outdent',
        'indent',
        '|',
        'undo',
        'redo',
      ],
      shouldNotGroupWhenFull: true,
    },
  };

  AuthUser: any = null;
  accessRemmi: boolean = false;

  UserForm: FormGroup;
  public submitted: boolean = false;
  public loading: boolean = false;
  public error = null;
  public randomstring: any;
  filteredItems = [];

  options = {
    types: [],
    componentRestrictions: { country: 'AU' },
  };
  fullList: any[] = [];

  // related contacts variables
  attached_contacts: any = [];
  filteredContacts = [];
  full_attach_contact: any;
  attach_contact = null;
  queryParams: any = {};
  contact_to_update: String[] = [];
  disabled_tab: boolean = false;
  filteredListing: any;
  filteredProperty: any;
  property_Params: any = {};
  historyList: any[] = [];
  project_appointment_list: any[] = [];
  listing_appointment_list: any[] = [];
  streams: any = [];
  stats: any = {
    totalLeads: [],
  };
  keyword: string = '';
  history_keyword: string = '';
  users_to_share_with = [];
  teams_to_share_with = [];
  office_to_share_with = [];
  private_contact_owners = [];
  contact_editors = [];
  isPrivate: boolean = false;
  submittedBtn: boolean = false;

  // tags
  tagsData = [];
  tagsDataCopy = [];
  keywordTags: string = '';
  todo = [];

  // tag manager
  new_tag = [];
  tag_type = null;
  module_type = null;
  newTagTypePopUp: boolean = false;
  new_tag_popup: boolean = false;
  @ViewChild('contactFormElement') formElementRef!: ElementRef;
  formAllFields: { name: string; label: string }[] = [];
  numOfNotValidFields: number = 0;
  requiredErrorMessages = [];
  notDisplayRequiredMessage: boolean = true;
  isMobile: boolean;

  constructor(
    private _workflowService: WorkflowService,
    private dash: DashService,
    public lmService: LeadManagementService,
    private api: ApiService,
    private sharedService: SharedService,
    private tagMangerService: TagMangerService,
    private Auth: AuthService,
    private toastr: ToastrService,
    public userService: UserService,
    private _staffContactService: StaffContactService,
    private _historyService: HistoryService,
    public leads: LeadsService,
    private fb: FormBuilder,
    private formHelper: FormHelper,
    private localStorageService: LocalStorageService,
    private listingService: ListingPropertiesService,
    private store: Store<RootReducerState>,
    private router: Router,
    private redux: ReduxService,
    private message: MessageService,
    private _CalendarAPIService: CalendarAPIService,
    private _cdr: ChangeDetectorRef,
    private _settingService: SettingService,
    private remmiConfirm: RemmiConfirmService
  ) {
    this.UserForm = this.fb.group({
      isPrivate: [false],
      type: [null],
      contact_type: [null],
      add_title: [''],
      nick_name: [''],
      age: [''],
      company_type: [null],
      photo: [''],
      role_id: [''],
      office_id: [''],
      sub_office_id: [null],
      user_type: ['Contact'],
      username: [''],
      first_name: [''],
      last_name: [''],
      gender: [''],
      birthday: [''],
      preferred_contact_method: [''],
      authentication_type: [''],
      mobile_no: [''],
      telephone_no: [''],
      website: [''],
      position: [null],
      wechat: [''],
      email: [''],
      password: [''],
      company: [''],
      parent_id: [''],
      // address
      building_name: [''],
      company_name: [''],
      unit_no: [''],
      street_no: [''],
      street_name: [''],
      suburb: [null],
      state: [''],
      post_code: [''],
      country: [''],

      contact_listing_type: [''],
      contact_address: [''],
      tags: [[]],
    });
  }

  selected_Contact_Input_id: any;
  isCache: boolean = true;
  private resizeSubscription: Subscription;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['contactDetails']?.currentValue?.length > 0 && changes?.['contactDetails']?.firstChange) {
      this.contactDetails._id = changes?.['contactDetails']?.currentValue;
      let isCache = this.localStorageService.GetItem('isCache');
      let cacheIds;
      if (isCache !== null && isCache !== undefined) {
        cacheIds = Crypto.decrypt(isCache);
        cacheIds.forEach((ele, idx) => {
          if (ele === this.contactDetails._id) {
            this.isCache = false;
            cacheIds.splice(idx, 1);
            this.localStorageService.SetItem('isCache', Crypto.encrypt(cacheIds));
          }
        });
      }
    }
  }

  /**
   * Initializes the component by setting up default values, fetching necessary data,
   * and subscribing to various observables to update the UI dynamically.
   */
  ngOnInit(): void {
    this.findResponsive(); // Adjusts UI responsiveness
    // Subscribe to contract list updates and refresh listing if changes occur
    this.contractList?.subscribe({
      next: response => {
        if (response) {
          this.isCache = false;
          this.getAttachedListing();
        }
      },
    });
    this.lmService.is_new_lead = false; // Reset new lead flag
    // Load company data
    this.getTags();
    this.getListingTags();
    this.getSubOffices();
    this.lmService.tag_manager = false; // Disable tag manager
    // Handle task list updates
    this.renderTaskList?.subscribe({
      next: response => {
        if (response == true || response == false) {
          this.isCache = false;
          this.getTasks();
          this.getStream();
          this.message.getModuleHistory(true);
        }
      },
    });
    // Handle property list updates
    this.renderPropertyList?.subscribe({
      next: response => {
        if (response == true) {
          this.isCache = false;
          this.getProperties();
          this.getAttachedProperty();
          this.getAttachedListing();
          this.getListing();
        }
      },
    });
    // Get logged-in user details
    this.store.pipe(select(getLoggedInUserStatus)).subscribe({
      next: response => {
        this.AuthUser = response?.data;
      },
    });
    // Set office ID in the form
    this.UserForm.patchValue({
      office_id: this.api.getOfficeId(),
    });
    // Load additional data if editing a contact
    if (this.lmService.isEdit_show_div === 'edit_contact') {
      this.patchEditForm();
      setTimeout(() => {}, 500); // Placeholder timeout
      this.getAllTeamMembers();
      this.getOffices();
      this.getSharedContactDetails();
    }
    // Handle office change and reload listings
    this.Auth.getChangeUserOffice().subscribe({
      next: response => {
        if (response === 'change default office') {
          setTimeout(() => {
            this.getListing();
            this.getProperties();
          }, 500);
        }
      },
    });
    // Update UI when a lead is saved
    this.IsLeadSaved?.subscribe({
      next: () => {
        this.isCache = false;
        this.getStream();
        this.getAttachedContacts();
      },
    });
    // Update project list when a project is saved
    this.IsProjectSaved?.subscribe({
      next: () => {
        this.lmService.GetProjectList();
      },
    });
    // Handle stream search with debouncing
    this.searchStreams.pipe(debounceTime(400), distinctUntilChanged()).subscribe({
      next: (searchTerm: string) => {
        this.getStream(this.streamPage, 15, searchTerm);
      },
    });

    this.searchInput.pipe(debounceTime(400), distinctUntilChanged()).subscribe({
      next: response => {
        this.lmService.getContactList(1, 30, response);
      },
    });
  }

  // Detects screen size changes and updates the UI accordingly.
  findResponsive = () => {
    this.resizeSubscription = this.dash.screenSize$.subscribe({
      next: response => {
        if (response.width < 768) {
          this.isMobile = true;
          this.selectedItem = tabsConfig[this.rightActiveIndex];
        } else {
          this.isMobile = false;
        }
      },
    });
  };

  // Will be called & Fetch APIs after view is initialized
  ngAfterViewInit(): void {
    fromEvent(this.searchKeyword.nativeElement, 'input')
      .pipe(map((event: Event) => (event.target as HTMLInputElement).value))
      .pipe(debounceTime(50))
      .pipe(distinctUntilChanged())
      .subscribe({ next: () => this.filterTags() });
    if (this.lmService.isEdit_show_div === 'edit_contact') {
      this.getStaff();
    }
  }

  // Will be called when user navigate to another Page
  ngOnDestroy() {
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
    this.lmService.tag_manager = false;
  }

  // Delete Profile Image
  delProfileImage() {
    if (this.lmService.isEdit_show_div == 'edit_contact') {
      this.lmService.deleteImage(this.selectedContact?._id, this.selectedContact?.photo, 'users');
      this.UserForm.patchValue({
        photo: null,
      });
    } else {
      this.UserForm.patchValue({
        photo: null,
      });
    }
    // Clear the input value of the file, so that it can be re-selected
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  // Get UserForm values
  get f() {
    return this.UserForm.controls;
  }

  subOfficeList: any[] = [];
  private subOfficeDefaulted = false;
  private contactPatched = false;
  getSubOffices() {
    this._settingService.getSubOfficeList().subscribe({
      next: (response: any) => {
        this.subOfficeList = response?.data || [];
        this.applyDefaultSubOffice();
      },
    });
  }

  /**
   * Defaults the Sub Office field to the first option, same as the other office pickers.
   * For an existing contact, waits for `patchEditForm`'s patch to land first — it can arrive
   * after the sub office list and would otherwise overwrite the default with the contact's own
   * (empty) value.
   */
  applyDefaultSubOffice() {
    if (!this._settingService.isSubOfficeAutoDefaultEnabled()) {
      return;
    }
    if (this.subOfficeDefaulted || !this.subOfficeList.length) return;
    const hasExistingContact = !!(this.contactDetails?.contactid || this.contactDetails?._id);
    if (hasExistingContact && !this.contactPatched) return;

    this.subOfficeDefaulted = true;
    if (!this.UserForm.get('sub_office_id')?.value) {
      this.UserForm.get('sub_office_id')?.setValue(this.subOfficeList[0]._id);
    }
  }

  // Adjust splitter horizontally
  dynamicPanelSizes: number[] = [50, 50];
  onSplitterResize(e: any) {
    this.dynamicPanelSizes = [Math.round(e?.sizes[0]), Math.round(e?.sizes[1])];
    let panel_detail = {
      user_id: this.api.getUserId(),
      office_id: this.api.getOfficeId(),
      panal_size: this.dynamicPanelSizes,
      type: 'contact',
    };
    this.userService.splitUser(panel_detail).subscribe({
      next: () => {
        this.getSplitter();
      },
    });
  }

  // Fetch splitter's values from DB
  getSplitter() {
    this.userService.getSplitUser().subscribe({
      next: response => {
        if (response.data !== null && response.data?.panal_size) {
          this.dynamicPanelSizes = response['data']?.panal_size ? response['data']?.panal_size : [50, 50];
        }
      },
    });
  }

  alternativeInfo: ContactAlternativeRow[] = [];

  openAddressOverlayPanel(event) {
    setTimeout(() => {
      this.ops.show(event);
    }, 0);
  }

  updateAddress() {
    // Construct the address string using form values
    let address = `${this.UserForm.get('building_name').value ? `"${this.UserForm.get('building_name').value}"` : ''} ${
      this.UserForm.get('unit_no').value ? this.UserForm.get('unit_no').value : ''
    } ${this.UserForm.get('street_no').value ? this.UserForm.get('street_no').value : ''} ${
      this.UserForm.get('street_name').value ? this.UserForm.get('street_name').value + ',' : ''
    } ${this.UserForm.get('suburb').value?.suburb ? this.UserForm.get('suburb').value?.suburb + ',' : ''} ${
      this.UserForm.get('state').value ? this.UserForm.get('state').value : ''
    } ${this.UserForm.get('post_code').value ? this.UserForm.get('post_code').value : ''}`;

    // If both unit number and street number are provided, format the address with a '/'
    if (this.UserForm?.get('unit_no')?.value?.trim() && this.UserForm?.get('street_no')?.value?.trim()) {
      let streetNoIndex = address.indexOf(this.UserForm?.get('street_no')?.value?.trim());

      // Insert '/' between unit number and street number
      address = address.substring(0, streetNoIndex - 1) + address.substring(streetNoIndex);
      address = [address.slice(0, streetNoIndex), '/', address.slice(streetNoIndex)].join('');
    }

    // Update the form field with the formatted address
    this.UserForm.patchValue({
      contact_address: address.trim(),
    });
  }

  imageError = false;

  // Get Form's specific values
  get first_name() {
    return this.UserForm.get('first_name');
  }
  get last_name() {
    return this.UserForm.get('last_name');
  }
  get company_name() {
    return this.UserForm.get('company_name');
  }
  // Set validations according to User type
  contactTypeChanged() {
    if (this.UserForm.controls['type'].value === 'Company') {
      this.UserForm.patchValue({
        company_name: this.UserForm.controls['first_name'].value + ' ' + this.UserForm.controls['last_name'].value,
        contact_type: 'Company',
      });
      this.UserForm?.controls?.['company_name']?.setValidators([Validators.required]);
      this.UserForm?.controls?.['company_type']?.setValidators([Validators.required]);
      this.UserForm?.controls?.['contact_type']?.setValidators([]);
      this.UserForm.controls['email'].setValidators([Validators.required, Validators.email]);
      this.UserForm?.controls?.['mobile_no']?.setValidators([]);
      this.UserForm?.controls?.['first_name']?.setValidators([]);
      this.UserForm?.controls?.['last_name']?.setValidators([]);
      this.UserForm?.updateValueAndValidity();
    } else {
      this.UserForm.controls['first_name'].setValidators([Validators.required]);
      this.UserForm.controls['last_name'].setValidators([]);
      this.UserForm.controls['email'].setValidators([Validators.required, Validators.email]);
      this.UserForm.controls['contact_type'].setValidators([Validators.required, Validators.email]);
      this.UserForm?.controls?.['company_type']?.setValidators([]);
      this.UserForm?.controls?.['company_name']?.setValidators([]);
      this.UserForm?.controls?.['mobile_no']?.setValidators([]);
      this.UserForm?.updateValueAndValidity();
    }
  }

  contactConflict: boolean = false;
  cContacts: any = [];
  /**
   * Creates or updates a contact based on form input.
   * Handles validation, API communication, and UI updates accordingly.
   */
  createContact(onlyUpdateOrCreate = '') {
    try {
      if (this.randomstring && this.randomstring?.length < 12) {
        this.toastr.error('Password must be at least 12 characters long');
        return;
      }
      if (!this.UserForm.controls['contact_address'].value) {
        this.resetContactAddress();
      }
      let isCache = this.localStorageService.GetItem('isCache');
      if (isCache !== null && isCache !== undefined) {
        let cache = Crypto.decrypt(isCache);
        cache.push(this.contactDetails._id);
        this.localStorageService.SetItem('isCache', Crypto.encrypt(cache));
      } else {
        let cache = [];
        cache.push(this.contactDetails._id);
        this.localStorageService.SetItem('isCache', Crypto.encrypt(cache));
      }
      // Setting validators based on type selection
      if (this.UserForm.controls['type'].value === 'Company') {
        this.UserForm?.controls?.['company_name']?.setValidators([Validators.required]);
        this.UserForm.controls['email'].setValidators([Validators.required, Validators.email]);
        this.UserForm?.controls?.['mobile_no']?.setValidators([]);
        this.UserForm?.controls?.['first_name']?.setValidators([]);
        this.UserForm?.controls?.['last_name']?.setValidators([]);
        this.UserForm?.updateValueAndValidity();
      } else {
        this.UserForm.controls['first_name'].setValidators([Validators.required]);
        this.UserForm.controls['last_name'].setValidators([]);
        this.UserForm.controls['email'].setValidators([Validators.required, Validators.email]);
        this.UserForm?.controls?.['company_name']?.setValidators([]);
        this.UserForm?.controls?.['mobile_no']?.setValidators([]);
        this.UserForm?.updateValueAndValidity();
      }
      this.submitted = true;
      this.submittedBtn = true;
      this.lmService.tag_manager = false;
      // Updating form values before submission
      this.UserForm.patchValue({
        tags: this.todo,
        username: this.UserForm.get('email').value,
      });
      if (this.UserForm.controls['type'].value === 'Company') {
        this.UserForm.patchValue({
          first_name: this.UserForm.controls['company_name'].value,
          last_name: '',
          contact_type: null,
        });
      }
      if (this.UserForm.controls['type'].value === 'Contact') {
        this.UserForm.patchValue({
          company_name: '',
          company_type: null,
        });
      }
      // Form validation check
      this.formHelper.validateAllFormFields(this.UserForm);
      if (!this.UserForm.valid) {
        let fields: any = Object.entries(this.UserForm.controls)
          .reduce((acc, [key, value]) => {
            if (value.status === 'INVALID') {
              acc.push(this.formAllFields.find(errorfield => errorfield.name === key) || undefined);
            }
            return acc;
          }, [])
          ?.filter(error_field => error_field !== undefined && error_field !== null);
        fields && this.validateFieldsOnRequest(fields);
        this.submittedBtn = false;
        return;
      }
      // Handling contact update
      if (this.lmService.isEdit_show_div == 'edit_contact') {
        delete this.UserForm.value['role_id'];
        delete this.UserForm.value['user_type'];
        delete this.UserForm.value['isPrivate'];
        if (this.UserForm.value['photo'] == this.selectedContact?.photo || this.containsSpecificURL(this.UserForm.value['photo'])) {
          delete this.UserForm.value['photo'];
        }
        this.loading = true;
        let form_data = this.UserForm.value;
        Object.assign(form_data, toAlternativePayload(this.alternativeInfo));
        form_data['password'] = this.randomstring;
        form_data['mobile_no'] = this.UserForm.controls['mobile_no'].value;
        // Handling contact logos
        if (this.logos?.length) {
          let newPhotos = this.logos.filter(img => !img.hasOwnProperty('_id'));
          form_data['logos'] = newPhotos;
        }
        let cont_id = this.contactDetails?.contactid || this.contactDetails?._id || this.selected_Contact_Input_id;
        // Updating contact via API
        this.userService.updateContact(cont_id, form_data).subscribe({
          next: () => {
            this.submitted = false;
            this.submittedBtn = false;
            this.loading = false;
            if (this.UserForm.controls['type'].value === 'Company') {
              this.toastr.success('Company has been updated');
            } else {
              this.toastr.success('Contact has been updated');
            }
            this.isPropertyOpen.emit(true);
            // Updating form values post-update
            this.UserForm.patchValue({
              role_id: this.current_role_id,
              office_id: this.api.getOfficeId(),
              user_type: 'Contact',
            });
            // Updating tab details
            this.lmService.tab_levels = this.lmService.tab_levels.map(el => {
              if (el._id == cont_id) {
                el.name = 'Contact - ' + this.UserForm.controls['first_name'].value + ' ' + this.UserForm.controls['last_name'].value;
              }
              return el;
            });
            let tab = this.lmService.tab_levels.find(el => el.name.includes('Contact') && el.data !== null);
            if (onlyUpdateOrCreate !== 'onlyUpdate') {
              if (tab) {
                let ind = this.lmService.tab_levels.indexOf(tab);
                this.UserForm.reset();
                this.isContactClose.emit({ level: tab, index: ind });
              }
            }
            this.emitterObject.emit({ onlyUpdateOrCreate: onlyUpdateOrCreate, id: cont_id });
            this.updatedContact.emit(true);
            this.isCache = false;
            this.message.getModuleHistory(true);
            this.numOfNotValidFields = this.requiredErrorMessages.length = 0;
          },
          error: error => {
            this.submittedBtn = false;
            this.loading = false;
            let { fields, all_fields } = error;
            if (fields?.length > 0) {
              this.formAllFields = fields.map(error_field => {
                let isExistsField = all_fields?.find(field => field.name === error_field);
                return isExistsField ? { name: error_field, label: isExistsField?.label || '' } : error_field;
              });
              this.toastr.error(error.message);
              this.validateFieldsOnRequest(fields);
            } else if (error?.message) {
              this.toastr.error(error.message);
            } else {
              this.toastr.error(error.message);
            }
          },
        });
      }
    } catch (error) {
      console.error(error);
    }
  }

  // Check if the Url exist in param value or not
  containsSpecificURL(photoValue: string): boolean {
    const urlPattern = 'https://remmi-xm.s3.ap-southeast-2.amazonaws.com/';
    return photoValue && photoValue.includes(urlPattern);
  }

  onSelectFile(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length) {
      const file = target.files[0];
      // Step 1: Check for allowed formats
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      if (!allowedTypes.includes(file.type)) {
        this.toastr.error('Unsupported file format! Please upload valid image');
        target.value = ''; // Reset the file input
        return;
      }

      // Step 2: Read file if valid
      const fileReader: FileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        this.UserForm.patchValue({
          photo: fileReader.result,
        });
        this.updateProfileOnImageChange();
      };
    }
  }

  // Random password generate
  public generatePassword() {
    this.randomstring = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }

  // Fetch filtered suburb from API
  filterItems(event) {
    let query = event.query;
    this.sharedService.searchSuburb(query).subscribe({
      next: response => {
        this.filteredItems = [];
        this.filteredItems = response?.data;
      },
    });
  }

  // -----------------------------------------------------------------------------------------
  // -----------------------------------Table Code--------------------------------------------
  staffOwner = [];
  shareStaffUser = [];
  // Fetches staff information with the specified parameters such as page, per_page, role, and query
  getStaff(
    page = null, // The current page number for pagination
    per_page = 30, // Number of staff per page
    role = this.role_id, // The role ID to filter staff by role
    query = '', // The search query to filter staff by name or other fields
    SortBy = this.SortBy, // The sorting field for staff data
    uid = this.api.getUserId(), // The user ID to get staff data for a specific user
    officeid = this.api.getOfficeId() // The office ID to filter staff by office
  ) {
    // Check if both user ID (uid) and office ID (officeid) are provided
    if (uid && officeid) {
      // Use the SortBy value (already set or passed) to sort the staff data
      SortBy = this.SortBy;
      this.userService.getOfficeStaff(page, per_page, role, query, uid, officeid, SortBy).subscribe({
        next: response => {
          this.staffUsers = response.data;
          this.staffOwner = response.data;
          this.shareStaffUser = response.data;
        },
      });
    }
  }

  get preferMethod() {
    return this.UserForm.get('preferred_contact_method')?.value || []; // Ensure it doesn't return undefined
  }

  // -----------------------------------------------------------------------------------
  // ---------------------------------RIGHT Bar--------------------------------------------------
  primary_contact_id: any;
  // Patch data in Contact's Edit form
  patchEditForm() {
    this.isCache = false;
    this.selected_Contact_Input_id = this.contactDetails.contactid ? this.contactDetails.contactid : this.contactDetails._id;
    let id = this.contactDetails.contactid ? this.contactDetails.contactid : this.contactDetails._id;
    if (id) {
      this.userService.getContactUser(id).subscribe({
        next: response => {
          this.primary_contact_id = response?.data?._id;
          this.lmService['visibilitySetting'] = response?.visibility_setting;
          this.alternativeInfo = toAlternativeRows(response['data']);
          this.selectedContact = response?.data;
          if (
            this.selectedContact?.editors?.includes(this.api.getUserId()) ||
            this.AuthUser?.role === 'Master Admin' ||
            this.AuthUser?.role?.toLowerCase() === 'operations manager' ||
            this.selectedContact?.user_id === this.AuthUser?._id
          ) {
            this.isPrivate = false;
          } else if (!this.userPermission.includes('contact.edit')) {
            this.isPrivate = true;
          } else if (this.lmService.visibilitySetting?.viewRoles?.includes(this.userRoleId)) {
            this.isPrivate = false;
          } else if (
            this.AuthUser?.role !== 'Master Admin' &&
            this.AuthUser?.role !== 'operations manager' &&
            (this.selectedContact?.isPrivate == true || this.lmService?.visibilitySetting?.is_visibility_private == true) &&
            this.selectedContact?.user_id !== this.AuthUser?._id
          ) {
            this.selectedContact.mobile_no = this.transformPhoneNumber(this.selectedContact.mobile_no);
            this.selectedContact.email = this.transformEmail(this.selectedContact.email);
            this.isPrivate = true;
            this.UserForm.get('mobile_no').disable();
            this.UserForm.get('email').disable();
          } else if (
            this.AuthUser?.role !== 'Master Admin' &&
            this.AuthUser?.role !== 'operations manager' &&
            this.selectedContact?.user_id !== this.AuthUser?._id
          ) {
            if (!this.lmService?.visibilitySetting?.is_visibility_edit) {
              this.isPrivate = false;
            } else {
              this.isPrivate = true;
            }
          } else if (!this.lmService?.visibilitySetting?.is_visibility_edit) {
            this.selectedContact.mobile_no = this.transformPhoneNumber(this.selectedContact.mobile_no);
            this.selectedContact.email = this.transformEmail(this.selectedContact.email);
            this.isPrivate = true;
            this.UserForm.get('mobile_no').disable();
            this.UserForm.get('email').disable();
          }
          this.emailTo = this.selectedContact.email;
          this.private_contact_owners = this.selectedContact?.owners;
          this.contact_editors = this.selectedContact?.editors;
          this.logos = this.selectedContact?.logos?.data;
          Object.keys(this.UserForm.controls).forEach(key => {
            if (key !== 'logos' && key !== 'tags' && key !== 'preferred_contact_method') {
              this.UserForm.controls[key].setValue(this.selectedContact[key] === null ? null : this.selectedContact[key]);
            } else if (key == 'logos') {
              this.UserForm.controls[key].setValue(this.selectedContact[key] === null ? null : this.selectedContact?.logos?.data);
            } else if (key == 'tags') {
              this.UserForm.controls[key].setValue(this.selectedContact[key] === null ? [] : this.selectedContact[key]);
              this.todo = this.selectedContact[key]?.map(item => {
                if (typeof item === 'string') {
                  return { tag_name: item };
                } else {
                  return item;
                }
              });
              if (this.todo == undefined || this.todo == null) {
                this.todo = [];
              }
            } else if (key == 'preferred_contact_method') {
              if (Array.isArray(this.selectedContact[key])) {
                this.UserForm.controls[key].setValue(this.selectedContact[key] === null ? null : this.selectedContact[key]);
              } else {
                this.UserForm.controls[key].setValue('');
              }
            }
          });
          this.UserForm.patchValue({
            first_name: response?.data?.first_name || '',
          });
          this.contactPatched = true;
          this.applyDefaultSubOffice();
          this.isCache = false;
          this.getCompany();
          this.GetMetaStatsForAllTabs();
          this.getSplitter();
          this.checkProcessRunning(id);
          this.getStream();
        },
      });
    }
  }
  no_process_run: boolean = false;
  // Fetch info to check automation if there is any process running.
  checkProcessRunning(id) {
    this.sharedService.getWorkFlowProcess(id).subscribe({
      next: response => {
        this.no_process_run = !response?.data?.length ? true : false;
      },
    });
  }
  // Hide mobile number using *
  private transformPhoneNumber(phoneNumber: string): string {
    if (phoneNumber && phoneNumber.length >= 3) {
      return '***' + phoneNumber.slice(-3);
    } else {
      return phoneNumber;
    }
  }
  // Hide email using *
  private transformEmail(email: string): string {
    if (email && email.indexOf('@') > 1) {
      const parts = email.split('@');
      const hiddenPart = '*'.repeat(parts[0].length - 1);
      return parts[0][0] + hiddenPart + '@' + parts[1];
    } else {
      return email;
    }
  }

  companies = null;
  public searchInput = new Subject<string>();
  full_company: any;
  // Select company from the dropdown
  selectCompany(e) {
    this.full_company = e;
    this.companies = `${e?.name}`;
    this.queryParams.contact_id = this.selected_Contact_Input_id ? this.selected_Contact_Input_id : this.insertedUserId;
    this.queryParams.related_contact_id = e?._id;
  }
  // Associate a company to the contact
  attachCompany() {
    let contact_id = this.contactDetails?._id ? this.contactDetails?._id : this.insertedUserId;
    if (contact_id) {
      this.loading = true;
      // Check if company is selected
      if (!this.full_company) {
        this.loading = false;
        this.toastr.error('Please select company first');
        return;
      } else {
        // Check if company is already associated or not
        let findContact = this.attach_company?.find(item => item?.contact?._id == this.full_company?._id);
        if (findContact) {
          this.toastr.error('Company is already associate to this Contact');
          this.loading = false;
          return;
        } else {
          this.queryParams.relation = [];
          let payLoad = {
            contact_id: this.queryParams.contact_id ? this.queryParams.contact_id : this.insertedUserId,
            company_id: this.queryParams.related_contact_id,
            relation: [],
          };
          this.userService.addCompanyToContact(payLoad).subscribe({
            next: () => {
              this.companies = null;
              this.message.sendMessage({
                isClearItems: true,
              });
              this.full_company = null;
              this.loading = false;
              this.isCache = false;
              this.queryParams = {};
              this.toastr.success('Company added successfully');
              this.getCompany();
            },
            error: err => {
              let message = err?.message || err?.error?.message;
              this.toastr.error(message);
              this.loading = false;
            },
          });
        }
      }
    } else {
      this.toastr.error('First create contact');
    }
  }
  attach_company: any[] = [];
  // Fetch companies that is associated to the contact
  getCompany() {
    this.attach_company = [];
    let getAttachContact = this.selected_Contact_Input_id;
    if (getAttachContact) {
      this.isCache = false;
      this.userService.getContactCampaigns(getAttachContact).subscribe({
        next: response => {
          this.isCache = true;
          this.attach_company = response?.data;
        },
      });
    }
  }
  // Delete associated company to the contact
  deleteCompany(id, companyName?: string) {
    this.remmiConfirm
      .delete({
        title: 'Remove Company?',
        message: 'This company will be unlinked from this contact.',
        subject: companyName,
        confirmLabel: 'Remove',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          this.deleteCompanyNow(id);
        }
      });
  }

  private deleteCompanyNow(id) {
    let payload = {
      contact_id: this.primary_contact_id ? this.primary_contact_id : this.insertedUserId,
      company_id: id,
    };
    this.userService.deleteContactCompany(payload).subscribe({
      next: () => {
        this.getCompany();
        this.toastr.success('Deleted successfully');
      },
    });
  }

  // Open sidebar to edit different module's forms
  openRightModal(contact, addOrEdit) {
    if (addOrEdit == 'edit_listing_property') {
      if (this.isMobile == true) {
        this.router.navigate(['/listings/listing-properties'], {
          queryParams: { id: contact?._id },
        });
      } else {
        this.lmService.listing_show_div = addOrEdit;
        this.lmService.addTabInLevels('Listing' + ' - ' + contact?.property_address, contact?._id, contact);
        this.lmService.is_new_listing = false;
        this.lmService.contact_showRightBar = true;
        this._cdr.detectChanges();
      }
    } else if (addOrEdit === 'add_contract') {
      if (this.isMobile == true) {
        this.router.navigate(['/contracts'], { queryParams: { id: 'createnew' } });
      } else {
        this.lmService.contract_show_div = addOrEdit;
        this.lmService.addTabInLevels('Contract', 'createnew', null);
        this.lmService.propertyId = this.lmService.propIdForRightBar;
        this.lmService.contractId = null;
        this.lmService.contact_showRightBar = true;
      }
    } else if (addOrEdit == 'edit_contract') {
      if (this.isMobile == true) {
        this.router.navigate(['/contracts'], { queryParams: { id: contact?._id } });
      } else {
        let is_listing_contract = contact?.is_listing_contract === false ? false : contact?.is_listing_contract;
        if (is_listing_contract == false) {
          this.lmService.addTabInLevels(`EOI - ${contact?.lot_name}`, contact?._id, contact);
          this.lmService.contact_showRightBar = true;
        } else {
          if (this.userPermission.includes('contract.manage') || this.userPermission.includes('contract.edit') || this.userRole == 'master admin') {
            let name: any;
            this.lmService.contract_show_div = addOrEdit;
            if (contact?.buyer) {
              name = contact?.buyer[0];
            }
            let exactName = name ? name : '';
            this.lmService.addTabInLevels('Contract' + ' - ' + exactName + ' - ' + contact?.property_address, contact?._id, contact);
            this.lmService.contractId = contact?._id;
            this.lmService.propertyId = null;
          } else {
            this.toastr.error('Access denied');
          }
        }
      }
    } else if (addOrEdit == 'edit_property') {
      if (this.isMobile == true) {
        this.router.navigate(['/property/properties'], { queryParams: { id: contact?._id } });
      } else {
        this.lmService.property_show_div = addOrEdit;
        this.lmService.addTabInLevels('Property' + ' - ' + contact?.property_address, contact?._id, contact);
      }
    } else if (addOrEdit == 'add_property') {
      if (this.isMobile == true) {
        this.router.navigate(['/property/properties'], { queryParams: { id: 'createnew' } });
      } else {
        this.lmService.property_show_div = addOrEdit;
        this.lmService.addTabInLevels('Property', 'new');
      }
    } else if (addOrEdit == 'edit_contact') {
      if (this.isMobile == true) {
        this.router.navigate(['/setting/office-contact'], { queryParams: { id: contact?._id } });
      } else {
        this.lmService.isEdit_show_div = addOrEdit;
        this.lmService.contact_showRightBar = true;
        this.lmService.addTabInLevels(`Contact-${contact?.full_name}`, contact?._id, contact, {}, 'contact');
        this.selectedContact = contact;
      }
    } else if (addOrEdit == 'add_contact') {
      if (this.isMobile == true) {
        this.router.navigate(['/setting/office-contact'], { queryParams: { id: 'createnew' } });
      } else {
        this.lmService.contact_show_div = addOrEdit;
        this.lmService.contact_showRightBar = true;
        this.disabled_tab = true;
        this.lmService.addTabInLevels('Contact', 'new', null, {}, 'contact');
        this.UserForm.patchValue({
          role_id: this.current_role_id,
          office_id: this.api.getOfficeId(),
          user_type: 'Contact',
        });
        this.subOfficeDefaulted = false;
        this.applyDefaultSubOffice();
      }
    }
  }
  // Close all the edit forms and sidebar
  closeRightBar() {
    this.lmService.tab_levels = [];
    this.lmService.contact_showRightBar = false;
    this.selectedContact = null;
    this.logos = [];
    this.UserForm.reset();
    this.UserForm.patchValue({
      role_id: this.current_role_id,
      office_id: this.api.getOfficeId(),
      user_type: 'Contact',
    });
    this.subOfficeDefaulted = false;
    this.applyDefaultSubOffice();
    $('.UserForm_tabs .tab-pane').removeClass('active show');
    $('.UserForm_li li a').removeClass('active');

    $('#userinfo').addClass('active show');
    $('.listing_detail').addClass('active');
  }

  // Image uploading
  onSelect(event) {
    if (this.logos == null) {
      this.logos = [];
    }
    if (event.addedFiles && event.addedFiles.length) {
      for (let i = 0; i < event.addedFiles.length; i++) {
        let logoName = event.addedFiles[i].name;
        const fileReader: FileReader = new FileReader();
        fileReader.readAsDataURL(event.addedFiles[i]);
        fileReader.onload = () => {
          this.logos.push({ name: logoName, file: fileReader.result });
        };
      }
    }
  }
  // Patch data of suburb field
  suburbSelection(e) {
    this.UserForm.patchValue({
      suburb: `${e?.suburb} ${e?.state} ${e?.postcode}`,
    });
  }

  resetContactAddress() {
    this.UserForm.patchValue({
      building_name: null,
      unit_no: null,
      street_no: null,
      street_name: null,
      suburb: null,
      state: null,
      post_code: null,
      country: null,
    });
  }

  // Set form's fields values with address data fetching from Google API
  handleAddressChange(address: any) {
    this.resetContactAddress();

    address?.address_components.forEach(el => {
      el.types.forEach(type => {
        if (type === 'premise') {
          this.UserForm.patchValue({
            building_name: el?.long_name,
          });
        } else if (type == 'subpremise') {
          this.UserForm.patchValue({
            unit_no: el?.long_name,
          });
        } else if (type === 'street_number') {
          this.UserForm.patchValue({
            street_no: el?.long_name,
          });
        } else if (type === 'route') {
          // street name
          this.UserForm.patchValue({
            street_name: el?.long_name,
          });
        } else if (type === 'locality') {
          this.UserForm.patchValue({
            suburb: el?.long_name,
          });
        } else if (type === 'administrative_area_level_1') {
          // State
          this.UserForm.patchValue({
            state: el?.short_name,
          });
        } else if (type === 'postal_code') {
          this.UserForm.patchValue({
            post_code: el?.short_name,
          });
        } else if (type === 'country') {
          this.UserForm.patchValue({
            country: el?.long_name,
          });
        }
      });
    });

    this.UserForm.patchValue({
      contact_address: address?.formatted_address,
    });
  }

  // Fetch Associated Tasks of contact from API
  getTasks() {
    try {
      this.userService.getContactTasks(this.selected_Contact_Input_id).subscribe({
        next: response => {
          this.isCache = true;
          let fullListData = response.data?.map(el => {
            let today = moment();
            const dueDate = moment(el?.due_date);
            const isFutureDate = dueDate?.isSame(today, 'day') || dueDate?.isBefore(today, 'day');
            if (el?.priority === 'High') {
              el = { ...el, is_exclamation: true };
            }
            if (isFutureDate) {
              el = { ...el, is_exclamation: true };
            }
            return el;
          });

          fullListData = fullListData.filter(el => el.taskStatusName !== 'Closed');
          this.fullList = fullListData;
        },
      });
    } catch (error) {}
  }
  rows: number = 4;
  totalRecord;
  // Fetch Associated Streams of contact from API
  getStream(page = 1, per_page = 15, query = null, bool = false) {
    if (this.selected_Contact_Input_id !== null && this.selected_Contact_Input_id != undefined && this.selected_Contact_Input_id != '') {
      this._historyService.getStreamDetailByModuleName(this.selected_Contact_Input_id, 'contact', page, per_page, query).subscribe({
        next: response => {
          window.setTimeout(() => {
            let stream = [];
            this.isLoading = true;
            stream = response.data;
            this.isCache = true;
            stream.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
            if (bool) {
              this.streams.push(...stream);
              if (stream.length < 14) {
                // If the stream contains fewer than 14 items, stop loading
                this.isLoading = false;
                this.streamRows = this.streams.length;
              } else {
                // Otherwise, add more rows to the stream
                this.streamRows += 15;
              }
            } else {
              // If 'bool' is false, reset the stream data to the new stream
              this.streamPage = 1; // Reset the stream page to 1
              this.streamRows = 15; // Reset the stream rows to 15
              this.streams = stream; // Set the streams to the new stream data
            }
            this.isSearching = false;
            this.totalRecord = response['meta']?.['pagination']?.['total'];
          }, 1000);
          this.stats = {
            ...response.stats,
            totalLeads: response?.stats?.totalleads?.reverse() || response?.stats?.totalleads || [],
          };
        },
        error: _ => {
          this.isLoading = false;
          this.isSearching = false;
        },
      });
    }
  }

  isAllowEdit(lead) {
    let userRole = Crypto.decrypt(this.localStorageService.GetItem('role'));
    let isAdminRole = userRole === 'master admin' || userRole === 'operations manager';
    let leadAgentId = lead?.Owner === this.api.getUserId() || lead?.agent === this.api.getUserId();

    return isAdminRole || leadAgentId ? true : false;
  }

  // Handle event emitter coming from Parent component
  SaveClicked(e) {
    if (e == true) {
      this.lmService.is_new_lead = false;
      this.getTasks();
      this.getStream();
      this.getListing();
      this.lmService.reload_rightBar = false;
      setTimeout(() => {
        this.lmService.reload_rightBar = true;
      }, 100);
    }
  }

  // --------------------------------------related contacts start -------------------
  // Show delete confirmation popup
  deleteAttachedContact(id) {
    this.remmiConfirm
      .delete({
        title: 'Remove Related Contact?',
        message: 'This contact will be unlinked from the current contact.',
        confirmLabel: 'Remove',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          this.deleteContactNow(id);
        }
      });
  }
  // Remove attached contacts from contact
  deleteContactNow(id) {
    this.userService.deleteRelatedContacts(id).subscribe({
      next: response => {
        this.isCache = false;
        this.toastr.success(response?.message);
        this.getAttachedContacts();
        setTimeout(() => {
          this.getStream();
        }, 300);
      },
    });
  }
  // Show first alphabet of first & last name if there isn't any photo
  showName(product) {
    if (product?.first_name && product?.last_name) {
      return product?.first_name?.charAt(0) + '' + product?.last_name?.charAt(0);
    } else if (product?.full_name) {
      return product?.full_name?.charAt(0);
    }
  }
  showUserName(user) {
    if (user?.first_name && user?.last_name) {
      let name = user?.first_name + ' ' + user?.last_name;
      return name;
    } else if (user?.full_name) {
      return user?.full_name;
    }
  }
  contact_search_complete: boolean = false;
  // Search contacts from list through search query
  searchContacts(event) {
    this.attach_contact = null;
    let value = event?.query.toLowerCase();
    this.searchInput.next(value);
    if (value && this.lmService?.shortContactCompany?.length === 0) {
      this.contact_search_complete = true;
    } else {
      this.contact_search_complete = false;
    }
  }

  btnDisable: boolean = true;
  isAttachingContact: boolean = false;

  @ViewChild('dt1') dt1: any;
  onSortChange(event: any): void {
    // Save the current scroll position
    const scrollTopBeforeSort = this.dt1.scrollableView.scrollBody.scrollTop;
    // Perform your sorting logic here
    const sortField = event.field;
    const sortOrder = event.order;
    this.AssociatedProjectsUsers.sort((a: any, b: any) => {
      let valueA, valueB;
      if (sortField === 'Project_Name') {
        valueA = a['Project_Name'] ? a['Project_Name'].toLowerCase() : '';
        valueB = b['Project_Name'] ? b['Project_Name'].toLowerCase() : '';
      } else if (sortField === 'createdon') {
        valueA = new Date(a['createdon']).getTime();
        valueB = new Date(b['createdon']).getTime();
      }
      let result = 0;
      if (valueA < valueB) result = -1;
      if (valueA > valueB) result = 1;
      return sortOrder * result;
    });
    // Reset scroll position after sort
    setTimeout(() => {
      this.dt1.scrollableView.scrollBody.scrollTop = scrollTopBeforeSort;
    });
  }

  contactSelection(element) {
    this.full_attach_contact = element;
    this.attach_contact = element?.name ? element.name?.trim() : '';
    !this.attach_contact ? (this.btnDisable = true) : (this.btnDisable = false);
    this.queryParams.contact_id = this.primary_contact_id ? this.primary_contact_id : this.insertedUserId;
    this.queryParams.related_contact_id = element?._id;
  }

  public selectedRelatedContact = null;
  insertedUserId: any;
  // Associate contact with selected contact
  attachContact() {
    if (this.isAttachingContact) {
      return;
    }
    let contact_id = this.primary_contact_id ? this.primary_contact_id : this.insertedUserId;
    if (contact_id) {
      this.loading = true;
      if (!this.full_attach_contact) {
        this.loading = false;
        this.toastr.error('Please select contact first');
        return;
      } else {
        this.btnDisable = true;
        let findContact = this.attached_contacts?.find(item => item?.contact?._id == this.full_attach_contact?._id);
        if (findContact) {
          this.toastr.error(
            `User is already associate to this contact ${findContact?.relation?.length > 0 ? 'as ' : ''}` +
              findContact?.relation?.toString()?.replace(/,/g, ', ')
          );
          this.loading = false;
          return;
        } else {
          this.isAttachingContact = true;
          this.queryParams.relation = [];
          let payload = {
            contact_id: this.queryParams.contact_id ? this.queryParams.contact_id : this.insertedUserId,
            related_contact_id: this.queryParams.related_contact_id,
            relation: [],
          };
          this.userService.addRelatedContact(payload).subscribe({
            next: () => {
              this.selectedRelatedContact = null;
              // this.message.sendMessage({
              //   isClearItems: true,
              // });
              this.full_attach_contact = null;
              this.attach_contact = null;
              this.btnDisable = true;
              this.loading = false;
              this.isAttachingContact = false;
              this.isCache = false;
              this.queryParams = {};
              this.toastr.success('Contact attached successfully');
              this.getAttachedContacts();
              this.getStream();
            },
            error: () => {
              this.loading = false;
              this.isAttachingContact = false;
            },
          });
        }
      }
    } else {
      this.toastr.error('First create contact');
    }
  }

  // Fetch associated contacts for the selected contact
  getAttachedContacts() {
    this.attached_contacts = [];
    this.userService.getRelatedContacts(this.selected_Contact_Input_id).subscribe({
      next: response => {
        this.isCache = true;
        this.lmService.isRelated_add = false;
        this.attached_contacts = response?.data;
      },
    });
  }

  // Listing Associate
  S3Path: string = environment.S3 + '/';
  getListing() {
    if (this.api.getOfficeId()) {
      this.listingService.getShortListing().subscribe({
        next: response => {
          this.isCache = false;
          this.propertiesList = response['data'].filter(x => x?.associate_property !== true);
        },
      });
    }
  }
  // Search listing from list through search query
  searchListing(event) {
    let filtered: any[] = [];
    let query = event.query;
    for (let i = 0; i < this.propertiesList?.length; i++) {
      let item = this.propertiesList[i];
      let name = `${item?.property_address?.toLowerCase()}`;
      if (name.indexOf(query.toLowerCase()) >= 0) {
        if (item?.property_address !== null) {
          filtered.push(item);
        }
      }
    }
    this.filteredListing = filtered;
    if (this.filteredListing?.length === 0) {
      this.property_search_complete = true;
    } else {
      this.property_search_complete = false;
    }
  }
  // Select listing to attach the contact
  listingSelection(e) {
    !this.attach_listing ? (this.listingBtnDisable = true) : (this.listingBtnDisable = false);
    this.property_Params.contact_id = this.selected_Contact_Input_id ? this.selected_Contact_Input_id : this.insertedUserId;
    this.property_Params.property_id = e?.value?._id;
    this.property_Params.associate_date = new Date();
  }
  // Associate listing with the selected contact
  attachListing() {
    this.loading = true;
    this.listingBtnDisable = true;
    if (!this.attach_listing) {
      this.loading = false;
      this.listingBtnDisable = false;
      return;
    } else {
      let findContact = this.attached_listing?.find(item => item?._id == this.attach_listing?._id);
      if (findContact) {
        this.toastr.error('Listing is already associate to this contact');
        this.loading = false;
        return;
      } else if (this.attached_listing?.find(x => x?.property?._id === this.property_Params.property_id)) {
        this.toastr.error('Listing already associated');
        this.loading = false;
      } else {
        this.property_Params.type = [];
        this.userService.savePropertyContact(this.property_Params).subscribe({
          next: () => {
            this.attach_listing = null;
            this.listingBtnDisable = true;
            this.property_Params = {};
            this.toastr.success('Listing attached successfully');
            this.loading = false;
            this.isCache = false;
            this.getAttachedListing();
            this.getStream();
          },
          error: () => {
            this.loading = false;
          },
        });
      }
    }
  }
  // Fetch associated listings for the selected contact
  getAttachedListing() {
    this.userService.getPropertyContact(this.selected_Contact_Input_id).subscribe({
      next: response => {
        this.isCache = true;
        this.attached_listing = [];
        this.attached_listing = response['data'];
        this.attached_listing = this.attached_listing.filter(
          x => x?.is_hide !== true && !x?.type.includes('Buyer Solicitor') && !x?.type.includes('Seller Solicitor')
        );
        let no_cancelled_contract = response['contract']?.filter(el => !el?.cancelledDate);
        let cancelled_contract = response['contract']?.filter(el => el?.cancelledDate);
        this.attached_contracts = [...no_cancelled_contract, ...cancelled_contract];
      },
    });
    this.getListingTags(true);
  }
  relatedContactTags: any[] = [];

  // Retrieve the list of connected listings
  getListingConnectedTo() {
    // Check if there are any attached listings
    if (this.attached_listing?.length) {
      // Create a shallow copy of the attached listings array
      const myArr = [...this?.attached_listing];
      // Map each listing's `_id` to a string prefixed with "s_"
      const mee = myArr.map(a => 's_' + a?._id.toString());
      // Return the formatted array
      return mee;
    }
  }

  // Handle drag-and-drop events for listing items
  dropListing(event: CdkDragDrop<any[]>, task) {
    // Check if the task has a 'type' property, and set 'contact_to_update' accordingly
    if (task.type) {
      this.contact_to_update = task.type;
    } else {
      this.contact_to_update = [];
    }
    // Prevent duplicate tags from being added to the contact
    if (task?.type?.includes(event.item.data)) {
      this.toastr.error('Tag is already associated with this contact');
      return;
    } else {
      // If the item is moved within the same container, reorder it
      if (event.previousContainer === event.container) {
        moveItemInArray(this.contact_to_update, event.previousIndex, event.currentIndex);
      } else {
        // If the item is dropped into a different container, add it as a new field
        this.addListingField(event.item.data, event.currentIndex, task);
      }
    }
  }

  // Add a listing field to the contact update array and trigger an update
  addListingField(fieldType: string, index: number, task) {
    // Insert the new field type at the specified index in the contact_to_update array
    this.contact_to_update?.splice(index, 0, fieldType);
    // Call the function to update listing tags after modifying the contact update array
    this.up_dateListingTags(task);
  }

  // Function to update listing tags for a specific task
  up_dateListingTags(task) {
    this.api
      .put('/contact-association/' + task?._id, {
        type: this.contact_to_update, // Sending updated contact type in the request body
      })
      .subscribe({
        next: () => {
          // Display success message upon successful update
          this.toastr.success('Listing contact updated successfully');
          // Reset the contact update array
          this.contact_to_update = [];
          // Disable cache to ensure fresh data fetch
          this.isCache = false;
          // Refresh the attached listing, history, and stream data after update
          this.getAttachedListing();
          this.message.getModuleHistory(true);
          this.getStream(this.selectedContact);
        },
        error: error => {
          // Display an error message if the update fails
          this.toastr.error(error.error.message);
        },
      });
  }
  // Remove tag from associate listing and refresh data
  removelistingTag(tag, task) {
    this.remmiConfirm
      .ask({
        title: 'Remove Tag?',
        message: 'This tag will be removed from the linked listing.',
        subject: tag,
        confirmLabel: 'Remove',
        tone: 'warning',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          this.contact_to_update = task?.type?.filter(item => item !== tag);
          this.up_dateListingTags(task);
        }
      });
  }

  // Show confirmation popup for deletion
  deleteAttachedListing(id, prop) {
    const isListing = prop === 'listing';
    this.remmiConfirm
      .delete({
        title: isListing ? 'Remove Listing?' : 'Remove Contract?',
        message: isListing ? 'This listing will be unlinked from this contact.' : 'This contract will be unlinked from this contact.',
        confirmLabel: 'Remove',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          isListing ? this.deleteListingNow(id) : this.deleteContractNow(id);
        }
      });
  }
  // Delete associated contract from selected contact
  deleteContractNow(id) {
    let body = {
      contract_id: id,
      contact_id: this.primary_contact_id ? this.primary_contact_id : this.insertedUserId,
    };
    this._staffContactService.updateContactAssociatedWithContract(body).subscribe(() => {
      this.isCache = false;
      this.getAttachedListing();
      this.toastr.success('Deleted successfully');
      this.getStream();
    });
  }
  // Delete associated listing from selected contact
  deleteListingNow(id) {
    this.userService.deletePropertyContact(id).subscribe({
      next: () => {
        this.isCache = false;
        this.toastr.success('Deleted successfully');
        this.getAttachedListing();
        this.getStream();
      },
    });
  }

  getTimeFormat(dateTime) {
    return moment(dateTime).format('hh:mm A');
  }

  // Property Associate
  propertied: any;
  // Fetch properties data
  getProperties() {
    this.sharedService.getDropDownItems('property', '', false, true).subscribe({
      next: response => {
        this.propertied = response['data'];
        this.isCache = true;
      },
    });
  }
  // Search properties from list by search query
  searchProperties(event) {
    let filtered: any[] = [];
    let query = event.query;
    for (let i = 0; i < this.propertied?.length; i++) {
      let item = this.propertied[i];
      let name = `${item?.property_address?.toLowerCase()}`;
      if (name.indexOf(query.toLowerCase()) >= 0) {
        if (item?.property_address !== null) {
          filtered.push(item);
        }
      }
    }
    this.filteredProperty = filtered;
    if (this.filteredProperty?.length === 0) {
      this.property_search_complete = true;
    } else {
      this.property_search_complete = false;
    }
  }
  // Selected property to associate
  propertySelection(e) {
    !this.attach_property ? (this.listingBtnDisable = true) : (this.listingBtnDisable = false);
    this.property_Params.contact_id = this.selected_Contact_Input_id ? this.selected_Contact_Input_id : this.insertedUserId;
    this.property_Params.property_data_id = e?.value?._id;
    this.property_Params.associate_date = new Date();
  }

  avoidClick: boolean = true;
  // Associate property for selected contact
  attachProperty() {
    this.loading = true;
    if (this.avoidClick) {
      this.avoidClick = false;
      if (!this.attach_property) {
        this.loading = false;
        return;
      } else {
        let findContact = this.attached_properties?.find(item => item?._id == this.attach_property?._id);
        if (findContact) {
          this.toastr.error('Property is already associate to this contact');
          this.loading = false;
          return;
        } else if (this.attached_properties?.find(x => x?.property_data?._id === this.property_Params.property_data_id)) {
          this.toastr.error('Property already associated');
          this.loading = false;
        } else {
          this.property_Params.type = [];
          this.userService.savePropertyContact(this.property_Params).subscribe({
            next: () => {
              this.attach_property = null;
              this.listingBtnDisable = true;
              this.property_Params = {};
              this.toastr.success('Property attached successfully');
              this.loading = false;
              this.isCache = false;
              this.getAttachedProperty();
              this.getStream();
            },
            error() {
              this.loading = false;
            },
          });
        }
      }
    }
    setTimeout(() => {
      this.avoidClick = true;
    }, 2000);
  }
  // Fetch property for selected contact
  getAttachedProperty() {
    this.userService.getPropertyContact(this.selected_Contact_Input_id).subscribe({
      next: response => {
        this.attached_properties = [];
        this.attached_properties = response['property_data']?.filter(x => x?.is_show_listing !== false);
        this.attached_properties = this.attached_properties?.filter(
          x => !x?.type.includes('Buyer Solicitor') && !x?.type.includes('Seller Solicitor')
        );
      },
    });
  }
  // Show confirmation popup for deletion
  deleteAttachedProperty(id) {
    this.remmiConfirm
      .delete({
        title: 'Remove Property?',
        message: 'This property will be unlinked from this contact.',
        confirmLabel: 'Remove',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          this.deletePropertyNow(id);
        }
      });
  }

  // Remove associated property from the selected contact
  deletePropertyNow(id) {
    let conId = this.primary_contact_id ? this.primary_contact_id : this.insertedUserId;
    this.userService.deletePropertyContactNow(id, conId).subscribe({
      next: () => {
        this.getAttachedProperty();
        this.getStream();
        this.toastr.success('Deleted successfully');
      },
    });
  }
  listingBtnDisable: boolean = true;
  // Save data while updating profile image of selected contact
  updateProfileOnImageChange() {
    this.submitted = true;
    this.submittedBtn = true;
    if (this.UserForm.get('contact_address')?.value == '') {
      this.UserForm.patchValue({
        building_name: null,
        unit_no: null,
        street_no: null,
        street_name: null,
        suburb: null,
        state: null,
        post_code: null,
        country: null,
      });
    }
    // Check telephone no is australian or not
    if (this.UserForm.get('telephone_no')?.value) {
      let numb = '';
      if (this.UserForm.get('telephone_no')?.value?.countryCode == 'AU') {
        numb = this.UserForm.get('telephone_no').value?.nationalNumber;
      } else {
        numb = this.UserForm.get('telephone_no').value?.internationalNumber;
      }
      this.UserForm.patchValue({
        telephone_no: numb,
      });
    }
    if (this.UserForm.get('mobile_no')?.value) {
      let numb = '';
      if (this.UserForm.get('mobile_no')?.value?.countryCode == 'AU') {
        numb = this.UserForm.get('mobile_no').value?.nationalNumber;
      } else {
        numb = this.UserForm.get('mobile_no').value?.internationalNumber;
      }
      this.UserForm.patchValue({
        mobile_no: numb,
      });
    }
    this.formHelper.validateAllFormFields(this.UserForm);
    if (!this.UserForm.valid) {
      let fields: any = Object.entries(this.UserForm.controls)
        .reduce((acc, [key, value]) => {
          if (value.status === 'INVALID') {
            acc.push(this.formAllFields.find(errorfield => errorfield.name === key) || undefined);
          }
          return acc;
        }, [])
        ?.filter(error_field => error_field !== undefined && error_field !== null);
      fields && this.validateFieldsOnRequest(fields);
      this.submittedBtn = false;
      return;
    }
    // if updating contact form
    if (this.lmService.isEdit_show_div == 'edit_contact') {
      delete this.UserForm.value['office_id'];
      delete this.UserForm.value['role_id'];
      delete this.UserForm.value['user_type'];
      delete this.UserForm.value['isPrivate'];
      if (this.UserForm.value['photo'] == this.selectedContact?.photo) {
        delete this.UserForm.value['photo'];
      }
      this.loading = true;
      let form_data = this.UserForm.value;

      if (this.logos?.length) {
        let newPhotos = this.logos.filter(img => !img.hasOwnProperty('_id'));
        form_data['logos'] = newPhotos;
      }
      this.userService.updateContact(this.contactDetails?._id, this.UserForm.value).subscribe({
        next: () => {
          this.submitted = false;
          this.submittedBtn = false;
          this.loading = false;
          this.toastr.success('Contact has been updated');
          this.UserForm.patchValue({
            role_id: this.current_role_id,
            office_id: this.api.getOfficeId(),
            user_type: 'Contact',
          });
          this.numOfNotValidFields = this.requiredErrorMessages.length = 0;
        },
        error: error => {
          this.submitted = false;
          this.submittedBtn = false;
          this.loading = false;
          let { fields, all_fields } = error;
          if (fields?.length > 0) {
            this.formAllFields = fields = fields?.map(error_field => {
              let isExistsField = all_fields?.find(field => field.name === error_field);
              if (isExistsField) {
                error_field = { name: error_field, label: isExistsField?.label || '' };
              }
              return error_field;
            });
            this.toastr.error(error.message);
            this.validateFieldsOnRequest(fields);
          } else if (error?.message) {
            this.toastr.error(error?.message);
          } else {
            this.toastr.error(error.message);
          }
        },
      });
    }
  }
  toggleCollapse(box) {
    box.isOpen = !box.isOpen;
  }
  addSpace(value) {
    return value?.replace(/,/g, ', ');
  }

  appointmentTab = 0;

  getProjectAppointments() {
    this._CalendarAPIService.getProjectContactEventsById(this.selectedContact?._id).subscribe({
      next: response => {
        this.project_appointment_list = response.data;
      },
    });
  }

  getListingAppointments() {
    this._CalendarAPIService.getListingContactEventsById(this.selectedContact?._id).subscribe({
      next: response => {
        this.listing_appointment_list = response.data;
      },
    });
  }

  private searchStreams = new Subject<string>();
  isSearching = false;
  // Search stream through API
  searchStream(e) {
    this.isSearching = true;
    this.searchStreams.next(e.target.value);
  }

  // Check if the date is valid
  isDate(value: any): boolean {
    return !isNaN(new Date(value).getTime());
  }

  // Parse date from string
  parseDate(dateString: string): Date | null {
    if (!dateString) return null;
    const isoDate = new Date(dateString);

    if (!isNaN(isoDate.getTime())) {
      return isoDate;
    }

    const [day, month, year] = dateString.split('/');
    if (day && month && year) {
      return new Date(Number(year), Number(month) - 1, Number(day));
    }

    return null;
  }

  // Add new task for associated contact
  addNewTask(task, new_or_edit) {
    let id = this.contactDetails?._id;
    if (new_or_edit == true) {
      this.lmService.addTabInLevels('Task', id, null, { extra: 'Contact' });
    } else if (new_or_edit == false) {
      this.lmService.addTabInLevels(`Task:` + ' REM-' + task?.id, task?._id, task);
    }
    setTimeout(() => {
      this.lmService.is_new_task = true;
    }, 50);
  }

  @Output() NewLeadInformation = new EventEmitter<Object>();
  newLead() {
    this.insertedUserId ? this.patchEditForm() : '';
    setTimeout(() => {
      this.leadTab();
    }, 1500);
  }

  leadTab() {
    let addDefaults: any = {};
    addDefaults.Owner = null;
    addDefaults.agent_responsible = this.AuthUser?._id;
    addDefaults.first_name = this.contactDetails?.first_name;
    addDefaults.last_name = this.contactDetails?.last_name;
    addDefaults.email = this.contactDetails?.email;
    addDefaults.mobile_phone = this.contactDetails?.mobile_no;
    addDefaults.telephone = this.contactDetails?.telephone_no;
    addDefaults.contactid = this.contactDetails?._id;
    addDefaults.lead_status = 'New';
    addDefaults.lead_create = 'contact';
    this.NewLeadInformation.emit({ addDefaults: addDefaults });
    this.lmService.is_new_lead = true;
    if (!this.isMobile) {
      // Add the lead to the levels
      this.lmService.addTabInLevels('Lead', null, null, { extra: 'Lead' }, 'lead');
    } else {
      // Navigate to the leads page
      this.router.navigate(['/leads'], { queryParams: { id: 'createnew' } });
    }
  }

  // --------drag drop relation
  drop(event: CdkDragDrop<any[]>, task) {
    if (task.relation) {
      this.contact_to_update = task.relation;
    }
    if (task?.relation?.includes(event.item.data)) {
      this.toastr.error('Tag is already associate to this contact');
      return;
    } else {
      if (event.previousContainer === event.container) {
        moveItemInArray(this.contact_to_update, event.previousIndex, event.currentIndex);
      } else {
        this.addField(event.item.data, event.currentIndex, task);
      }
    }
  }

  addField(fieldType: string, index: number, task) {
    this.contact_to_update?.splice(index, 0, fieldType);
    this.updateTags(task);
  }
  // Update tags from API
  updateTags(task) {
    this.api
      .put('/related-contacts/' + task?._id, {
        relation: this.contact_to_update,
      })
      .subscribe({
        next: response => {
          this.toastr.success(response.message);
          this.contact_to_update = [];
          this.isCache = false;
          this.getAttachedContacts();
          this.getStream();
        },
        error(err) {
          this.toastr.error(err);
        },
      });
  }
  // Remove tag & refresh data
  removeTag(tag, task) {
    this.remmiConfirm
      .ask({
        title: 'Remove Tag?',
        message: 'This relation tag will be removed from the related contact.',
        subject: tag,
        confirmLabel: 'Remove',
        tone: 'warning',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          this.contact_to_update = task?.relation?.filter(item => item !== tag);
          this.updateTags(task);
        }
      });
  }

  showPassword: boolean = true;
  public showHidePassword() {
    this.showPassword = !this.showPassword;
  }
  // Edit lead associated to contact
  _editLead(leadId: string) {
    let lead = this.stats['totalleads'].filter(itm => {
      return leadId == itm._id;
    });
    if (lead.length > -1) this.editLead(lead.shift());
  }
  // Edit lead associated to contact
  editLead(lead) {
    if (lead.agent != this.AuthUser._id && this.AuthUser?.role !== 'Operations Manager' && this.AuthUser.role !== 'Master Admin') return false;
    if (this.isMobile == true) {
      this.router.navigate(['/leads'], { queryParams: { id: lead?._id } });
    } else if (this.api.getUserId() === lead?.agent || this.AuthUser?.role == 'Master Admin' || this.AuthUser?.role == 'Operations Manager') {
      this.lmService.addTabInLevels('Lead' + ' - ' + lead?.first_name + ' ' + lead?.last_name, lead?._id, lead, null, 'lead');
    }
  }
  getConnectedTo() {
    if (this.attached_contacts?.length) {
      const myArr = [...this?.attached_contacts];
      const mee = myArr.map(a => 's_' + a?._id.toString());
      return mee;
    }
  }

  // Make COntact Private
  makePrivateContact() {
    this.loading = true;
    this.selectedContact.isPrivate = !this.selectedContact.isPrivate;
    this.userService
      .makePrivateContact(this.contactDetails?._id, {
        isPrivate: this.selectedContact.isPrivate,
      })
      .subscribe({
        next: () => {
          this.patchEditForm();
          this.loading = false;
        },
      });
  }

  removeAssignment(lead) {
    this.remmiConfirm
      .ask({
        title: 'Remove Assigned Lead?',
        message: 'This lead will be unlinked from this contact.',
        subject: [lead?.first_name, lead?.last_name].filter(Boolean).join(' '),
        confirmLabel: 'Remove',
        tone: 'warning',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          this.removeAssignmentNow(lead);
        }
      });
  }

  private removeAssignmentNow(lead) {
    this.leads.getAssignment(lead._id).subscribe({
      next: response => {
        this.getStream();
        this.toastr.success(response.message);
      },
    });
  }

  ShareContact() {
    if (this.office_to_share_with?.length > 0 || this.teams_to_share_with?.length > 0 || this.users_to_share_with?.length > 0) {
      this.userService
        .shareContact({
          teams: this.teams_to_share_with,
          users: this.users_to_share_with,
          office: this.office_to_share_with,
          contact_id: this.contactDetails?._id,
        })
        .subscribe({
          next: _ => {
            this.toastr.success('Contact has been shared');
            this.getSharedContactDetails();
          },
          error(error) {
            this.toastr.error(error?.message);
          },
        });
    } else {
      this.toastr.error('Please select user or team');
    }
  }

  ownContact() {
    this.userService
      .ownContact(this.contactDetails?._id, {
        owners: this.private_contact_owners,
      })
      .subscribe({
        next: _ => {
          this.toastr.success('Contact owner has been updated');
          this.patchEditForm();
        },
        error(error) {
          this.toastr.error(error?.message);
        },
      });
  }

  editContact() {
    if (this.contact_editors == null || !this.contact_editors.length) {
      this.toastr.warning('Please select editor for update');
      return false;
    } else {
      this.userService
        .editContact(this.contactDetails?._id, {
          editors: this.contact_editors,
        })
        .subscribe({
          next: _ => {
            this.toastr.success('Contact editor has been updated');
            this.patchEditForm();
          },
          error(error) {
            this.toastr.error(error?.message);
          },
        });
    }
  }

  offices: any = [];

  getOffices() {
    this.sharedService.getDropDownItems('offices').subscribe({
      next: response => {
        this.offices = response.data;
      },
    });
  }

  getAllTeamMembers() {
    if (this.api.getOfficeId()) {
      this.sharedService.getDropDownItems('teams').subscribe({
        next: response => {
          this.teams = response.data;
        },
      });
    }
  }

  getSharedContactDetails() {
    this.teams_to_share_with = [];
    this.users_to_share_with = [];
    this.office_to_share_with = [];
    this.userService.getSharedContact(this.contactDetails?._id).subscribe({
      next: response => {
        this.teams_to_share_with = response?.data?.teams;
        this.users_to_share_with = response?.data?.users;
        this.office_to_share_with = response?.data?.office;
      },
    });
  }

  requestEditingContact() {
    this.userService.requestEditingContact(this.selectedContact._id).subscribe({
      next: () => {
        this.toastr.success('Request for editing contact sent');
      },
    });
  }

  //------------------------------------------------ Tag Manger -----------------------------------------------
  closeTagManger() {
    this.lmService.tag_manager = false;
    this.resetTagSearch();
  }
  resetTagSearch() {
    this.keywordTags = null;
    this.tagsData = this.tagsDataCopy;
  }
  pushTagToArray(e) {
    let tagArr = this.tagsData.find(tagArr => tagArr.module_type == this.module_type?.name);
    if (tagArr?.data) {
      let tag_exist = tagArr?.data?.find(tag => tag?.tag_name?.toLowerCase().trim() == e.value.toLowerCase().trim());

      let tag_in_new_tag = [];

      if (this.new_tag?.length) {
        tag_in_new_tag = this.new_tag.filter(tag => tag?.toLowerCase().trim() == e.value.toLowerCase().trim());
      }

      if (tag_exist) {
        this.new_tag.splice(this.new_tag.indexOf(e.value.trim()), 1);
        this.toastr.error('Tag already exist');
      } else if (tag_in_new_tag?.length > 1) {
        this.getUnique();
        this.toastr.error('Tag is already entered');
      }
    }
  }

  getUnique() {
    var uniqueArray = [];
    // Loop through array values
    for (var value of this.new_tag) {
      if (uniqueArray.indexOf(value.toLowerCase().trim()) === -1) {
        uniqueArray.push(value.trim());
      }
    }
    this.new_tag = uniqueArray;
  }

  createTag() {
    this.loading = true;
    let payLoad = {};
    if (this.tag_type) {
      if (this.new_tag?.length > 1) {
        payLoad = {
          'tag_name[]': this.new_tag,
          module_id: this.contact_tag_module_id || '',
          type_id: this.tag_type,
          office_id: this.api.getOfficeId(),
          user_id: this.api.getUserId(),
        };
      } else {
        payLoad = {
          'tag_name[]': this.new_tag,
          module_id: this.contact_tag_module_id || '',
          type_id: this.tag_type,
          office_id: this.api.getOfficeId(),
          user_id: this.api.getUserId(),
        };
      }
      if (this.userRole == 'master admin' || this.userRole == 'operations manager') {
        this.tagMangerService.addTag(payLoad).subscribe({
          next: response => {
            if (response?.status == true) {
              this.toastr.success('Tag successfully created');
              this.isCache = false;
              this.getListingTags(true);
              this.getTags(true);
              this.new_tag = [];
              this.tag_type = null;
              this.new_tag_popup = false;
              this.loading = false;
            } else {
              this.toastr.error(response?.message);
              this.loading = false;
            }
          },
          error: error => {
            this.toastr.error(error?.error?.message ? error?.error?.message : error?.message);
            this.loading = false;
          },
        });
      } else {
        this.tagMangerService.requestTag(payLoad).subscribe({
          next: response => {
            if (response?.status == true) {
              this.toastr.success('Request sent successfully');
              this.new_tag = [];
              this.tag_type = '';
              this.new_tag_popup = false;
            } else {
              this.toastr.error(response?.message);
            }
            this.loading = false;
          },
          error: error => {
            this.toastr.error(error?.error?.message ? error?.error?.message : error?.message);
          },
        });
      }
    } else {
      this.toastr.error('Please select tag type');
      this.loading = false;
    }
  }

  createTagType() {
    this.loading = true;
    let payLoad = {
      module_id: this.tagsData[0]?._id,
      type: 'tag_types',
      name: this.tag_type,
      office_id: this.api.getOfficeId(),
      user_id: this.api.getUserId(),
    };
    this.tagMangerService.createTag(payLoad).subscribe({
      next: response => {
        if (response?.status == true) {
          this.toastr.success('Tag type successfully created');
          this.isCache = false;
          this.getListingTags(true);
          this.getTags(true);
          this.tag_type = null;
          this.newTagTypePopUp = false;
          this.module_type = null;
        } else {
          this.toastr.error(response?.message);
        }
        this.loading = false;
      },
      error: error => {
        this.toastr.error(error?.error?.message ? error?.error?.message : error?.message);
      },
    });
  }

  isNewTypeModel(event) {
    if (event?._id == 'createnew' || event?.value == 'createnew' || event?.value?._id == 'createnew') {
      this.newTagTypePopUp = true;
      setTimeout(() => {
        this.tag_type = null;
      });
    }
  }

  popTagFromArray() {
    // this.new_tag.splice(this.new_tag.indexOf(e.value.trim()), 1);
  }

  contactType: any[] = [];
  preferred_contact_method: any[] = [];
  companyType: any[] = [];
  companyRole: any[] = [];
  contact_tag_module_id: any;
  addTile: any[] = [];
  addType: { tag_name: string; value: string }[] = [
    { tag_name: 'Company', value: 'Company' },
    { tag_name: 'Individual', value: 'Contact' },
  ];

  dropTag(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      this.addTagInForm(event.currentIndex, event.item.data);
    }
  }
  addTagInForm(index, data) {
    let findInd = this.todo.find(el => el?._id == data?._id);

    if (!findInd) {
      this.todo?.splice(index, 0, data);
    } else {
      let removeIndex = this.todo.findIndex(el => el?._id == data?._id);
      this.todo?.splice(removeIndex, 1);
    }
  }
  removePublicTag(i) {
    this.todo?.splice(i, 1);
  }
  noTagsFound: boolean = false;
  filterTags() {
    this.tagsData = JSON.parse(JSON.stringify(this.tagsDataCopy));
    if (this.keywordTags) {
      this.tagsData.map(tagArr => {
        tagArr?.types?.map(type => {
          if (type?.name?.toLowerCase()?.includes(this.keywordTags.toLowerCase())) {
            return type;
          } else {
            type.data = type?.data?.filter(tag => tag?.tag_name?.toLowerCase().includes(this.keywordTags.toLowerCase()));
            return type;
          }
        });
        tagArr.data = tagArr?.data?.filter(tag => tag?.tag_name?.toLowerCase().includes(this.keywordTags.toLowerCase()));
        return tagArr;
      });
      this.tagsData.map(result => {
        result.types = result.types.filter(course => course?.data?.length);
        return result;
      });
    }
    this.noTagsFound = this.tagsData.every(group => !group.types || group.types.length === 0);
  }
  handleTabs(e) {
    if (e == 'clickView') {
      this.lmService.tag_manager = true;
    } else {
      this.lmService.tag_manager = false;
    }
  }

  duplicateRecords(lead) {
    this.leads.duplicateLead(lead._id, {}).subscribe({
      next: _ => {
        this.toastr.success('Duplicated');
        this.isCache = false;
        this.getStream();
      },
      error: () => {
        this.toastr.error('Something has gone wrong');
      },
    });
  }

  GetListingWorkflowProcesses() {
    this._workflowService.isWorkflowProcessTabOpened = true;
    this._workflowService.ActiveProcessList = [];
    this._workflowService.processRecordId = this.contactDetails?._id;
    this._workflowService.active_module_name = 'contacts';
    this._workflowService
      .GetAllProcessesByModule(this.contactDetails?._id, this._workflowService.module_array.filter(res => res.name === 'Contact')?.[0]?.module_value)
      .subscribe({
        next: response => {
          try {
            const { status, data, meta } = response;
            if (status) {
              !data?.length
                ? ((this.no_process_run = true), (this._workflowService.module_isStop = true))
                : ((this.no_process_run = false), (this._workflowService.module_isStop = false));
              this._workflowService.ActiveProcessList = data?.map(
                result =>
                  (result = {
                    ...result,
                    module: Utils.capitalizePhrase(result?.module?.split('_')?.join(' ')?.trim() || ''),
                  })
              );
              this._workflowService.centralizedProcessPagination = {
                ...this._workflowService.centralizedProcessPagination,
                per_page: 10,
                total_pages: Math.ceil(meta?.pagination?.total / 10),
                total: meta?.pagination?.total,
                numberOfRecords: this._workflowService.ActiveProcessList?.length > 10 ? 10 : this._workflowService.ActiveProcessList?.length,
              };
            } else {
              this._workflowService.ActiveProcessList = [];
            }
          } catch (error) {
            this._workflowService.ActiveProcessList = [];
          }
        },
      });
  }

  onChangeRightPanel(event) {
    if (event === 'Tasks') {
      if (this.lmService.isEdit_show_div === 'edit_contact' || this.insertedUserId) {
        this.isCache = false;
        this.getTasks();
      }
    } else if (event === 'Related Property') {
      this.lmService.isEdit_show_div = this.lmService.isEdit_show_div === null ? 'edit_contact' : this.lmService.isEdit_show_div;
      if (this.lmService.isEdit_show_div === 'edit_contact' || this.insertedUserId) {
        this.isCache = false;
        this.getListing();
        this.getProperties();
        this.getAttachedListing();
        this.getAttachedProperty();
        this.getListingTags(true);
      }
    } else if (event === 'Related Contacts') {
      if (this.lmService.isEdit_show_div === 'edit_contact' || this.insertedUserId) {
        this.lmService.getContactRelations(); // Fetch contact relations
        this.getAttachedContacts();
        this.getListingTags(true);
      }
    } else if (event === 'Associations') {
      if (this.lmService.isEdit_show_div === 'edit_contact' || this.insertedUserId) {
        this.GetAssociatedProjects();
        this.GetAgreementProjects();
        // Fetch project list if eligible
        if (this.GetAssociatedProjectEligibleStatus()) {
          this.lmService.GetProjectList();
        }
      }
    } else if (event === 'Appointments') {
      if (this.lmService.isEdit_show_div === 'edit_contact' || this.insertedUserId) {
        this.appointmentTab = 0;
        this.getProjectAppointments();
      }
    } else if (event === 'History') {
      if (this.lmService.isEdit_show_div === 'edit_contact' || this.insertedUserId) {
        this.historyList = [];
        this.message.getModuleHistory(true);
      }
    }
  }

  GetMetaStatsForAllTabs() {
    try {
      this.userService.getContactStats(this.selected_Contact_Input_id).subscribe({
        next: response => {
          const { data, status } = response;
          if (status) {
            const { appointmentsCount, propertiesCount, contractCount, relatedContactsCount, tasksCount } = data;
            appointmentsCount ? (this.project_appointment_list.length = appointmentsCount) : null;
            tasksCount ? (this.fullList.length = tasksCount) : null;
            propertiesCount ? (this.attached_listing.length = propertiesCount) : null;
            contractCount ? (this.attached_contracts.length = contractCount) : null;
            relatedContactsCount ? (this.attached_contacts.length = relatedContactsCount) : null;
          }
        },
      });
    } catch (error) {}
  }

  buildingNameChanged() {
    if (this.UserForm.controls['building_name'].value != '' && this.UserForm.controls['building_name'].value != null) {
      let new_address = `"${this.UserForm.get('building_name').value}" ${
        this.UserForm.get('unit_no').value ? this.UserForm.get('unit_no').value : ''
      } ${this.UserForm.get('street_no').value ? this.UserForm.get('street_no').value : ''} ${
        this.UserForm.get('street_name').value ? this.UserForm.get('street_name').value : ''
      } ${this.UserForm.get('suburb').value?.suburb ? this.UserForm.get('suburb').value?.suburb : ''} ${
        this.UserForm.get('state').value ? this.UserForm.get('state').value : ''
      } ${this.UserForm.get('post_code').value ? this.UserForm.get('post_code').value : ''} ${
        this.UserForm.get('country').value ? this.UserForm.get('country').value : ''
      }`;
      let addr = new_address.trim();
      this.UserForm.patchValue({
        contact_address: addr,
      });
    } else {
      let new_address = `${this.UserForm.get('building_name').value ? this.UserForm.get('building_name').value : ''} ${
        this.UserForm.get('unit_no').value ? this.UserForm.get('unit_no').value : ''
      } ${this.UserForm.get('street_no').value ? this.UserForm.get('street_no').value : ''} ${
        this.UserForm.get('street_name').value ? this.UserForm.get('street_name').value : ''
      } ${this.UserForm.get('suburb').value?.suburb ? this.UserForm.get('suburb').value?.suburb : ''} ${
        this.UserForm.get('state').value ? this.UserForm.get('state').value : ''
      } ${this.UserForm.get('post_code').value ? this.UserForm.get('post_code').value : ''} ${
        this.UserForm.get('country').value ? this.UserForm.get('country').value : ''
      }`;
      let addr = new_address.trim();
      this.UserForm.patchValue({
        contact_address: addr,
      });
    }
  }

  showMenu: boolean = false;
  getEmailTemplate() {
    this.sharedService.getEmailTemplate().subscribe({
      next: response => {
        this.emailTemplates = response.data;
        this.emailTemplates = this.emailTemplates.filter(x => x.type == 'contacts');
        this.emailTempSelected = this.emailTemplates[0];
        this.emailTempSelectedId = this.emailTempSelected?._id;
        this.email_modal = true;
        this.getTemplateBody();
      },
    });
  }

  getTemplateBody() {
    let searchEmail = this.emailTemplates.filter(x => x._id == this.emailTempSelectedId);
    if (searchEmail && searchEmail.length > 0) {
      this.emailTempSelected = searchEmail[0];
    }
    let body;
    let subject;
    body = this.emailTempSelected.body;
    subject = this.emailTempSelected.subject;
    const regex = /{([^}]+)}/g;
    const matchesBody = body.match(regex);
    const matchesSubject = subject.match(regex);
    let selectedBody = body;
    let selectedSubject = subject;
    if (matchesBody) {
      matchesBody.forEach(match => {
        const propertyName = match.substring(1, match.length - 1);
        const propertyValue = this.selectedContact[propertyName];
        selectedBody = selectedBody.replace(match, propertyValue);
      });
      this.emailBody = selectedBody;
    }
    if (matchesSubject) {
      matchesSubject.forEach(match => {
        const propertyName = match.substring(1, match.length - 1);
        const propertyValue = this.UserForm.get(propertyName).value;
        selectedSubject = selectedSubject.replace(match, propertyValue);
      });
      this.emailSubject = selectedSubject;
    } else {
      this.emailSubject = subject;
    }
  }

  sendEmail() {
    this.api
      .post('/send-email-to-user', {
        to: this.emailTo,
        subject: this.emailSubject,
        body: this.emailBody,
      })
      .subscribe({
        next: response => {
          if (response.status == true) {
            this.toastr.success('Email sent successfully');
            this.email_modal = false;
          } else {
            this.toastr.error(response.message);
          }
        },
      });
  }

  GetAssociatedProjectEligibleStatus(): boolean {
    let role = Crypto.decrypt(this.localStorageService.GetItem('role'));
    return ['master admin', 'operations manager'].includes(role?.toLocaleLowerCase());
  }

  AddNewProject: any[] = [];
  AssociatedProjectSelection: any[] = [];
  AssociatedProjectsUsers: any[] = [];
  GetAssociatedProjects() {
    this.userService.getAssociatedProjects(this.selectedContact?._id).subscribe({
      next: (response: any) => {
        const { status, data }: { status: boolean; data: any[] } = response;
        if (status && data?.length > 0) {
          this.AssociatedProjectsUsers = data?.map((project: any) => ({
            ...project,
            Project_Name: project?.project?.Project_Name || '',
          }));
        } else {
          this.AssociatedProjectsUsers = [];
        }
      },
    });
  }

  agreementProjectsUsers: any[] = [];
  agreement_dialog: boolean = false;
  agreement_detail = null;
  GetAgreementProjects() {
    this.userService.getAgreementProjects(this.selectedContact?._id).subscribe({
      next: (response: any) => {
        const { status, data }: { status: boolean; data: any[] } = response;
        if (status && data?.length > 0) {
          this.agreementProjectsUsers = data;
        }
      },
    });
  }

  openAgreement(agree) {
    this.agreement_dialog = true;
    this.agreement_detail = agree;
  }

  agreementhide(event) {
    if (event == true) {
      this.agreement_dialog = false;
      this.agreement_detail = null;
      this.GetAgreementProjects();
    }
  }

  // Associates or removes a user from a project based on the specified action
  AssociateUserToProject(action: 'add' | 'remove', project: any[]) {
    if (action === 'add') {
      this.runProjectAssociation(action, project);
      return;
    }
    if (!project?.length) {
      return;
    }
    this.remmiConfirm
      .delete({
        title: 'Remove From Project?',
        message: 'This contact will no longer be associated with the selected project.',
        subject: project.length === 1 ? project[0]?.Project_Name : `${project.length} projects selected`,
        confirmLabel: 'Remove',
      })
      .subscribe(isConfirmed => {
        if (isConfirmed) {
          this.runProjectAssociation(action, project);
        }
      });
  }

  private runProjectAssociation(action: 'add' | 'remove', project: any[]) {
    let promise_list: Observable<any>[] = []; // List to store API requests

    if (action === 'add') {
      // Loop through projects and push API post requests for association
      project.forEach((pro: any) => {
        promise_list.push(
          this.userService.associateUserToProject({
            projectid: pro?._id ? pro?._id : pro,
            user_id: this.selectedContact?._id ? this.selectedContact?._id : this.insertedUserId,
          })
        );
      });
    } else {
      // Loop through projects and push API delete requests for removal
      project.forEach((pro: any) => {
        promise_list.push(
          this.userService.deletedAssociateUserToProject({
            projectid: pro?.projectid ? pro?.projectid : pro,
            user_id: this.selectedContact?._id ? this.selectedContact?._id : this.insertedUserId,
          })
        );
      });
    }
    if (promise_list?.length > 0) {
      // Execute all API calls in parallel using forkJoin and properly handle deprecations
      forkJoin([...promise_list]).subscribe({
        next: () => {
          this.toastr.success(`${action === 'add' ? 'Added successfully' : 'Removed successfully'}`);
          this.GetAssociatedProjects(); // Refresh associated projects
          this.isCache = false; // Clear cache flag
          this.message.getModuleHistory(true);
          this.message.sendMessage({
            isClearItems: true,
          });
          this.AssociatedProjectSelection = this.AddNewProject = []; // Reset selections
        },
        error: () => {
          this.toastr.error(`Something went wrong`);
        },
      });
    }
  }

  validateFieldsOnRequest(fields: any[] = []) {
    if (fields?.length > 0) {
      fields?.forEach(field_error => {
        this.UserForm?.controls?.[field_error?.name]?.setValidators([Validators.required]);
        this.UserForm?.controls?.[field_error?.name]?.updateValueAndValidity();
      });
      this.numOfNotValidFields = this.requiredErrorMessages.length = 0;
      for (let prop in this.UserForm.controls) {
        if (this.UserForm.controls[prop].errors) {
          let fieldReqObj = {
            field: prop,
            message: `${fields?.find(textfield => textfield.name === prop)?.label || ''}`,
          };
          this.requiredErrorMessages.push(fieldReqObj);
          this.numOfNotValidFields++;
        }
      }
    }
  }

  // Activates the tab index based on the error message and scrolls to the relevant form field
  ActivateTabIndexByError(message: any) {
    let space_serrated: string[] = message?.split(' '); // Splitting the message into words
    if (space_serrated?.[0]?.trim()?.length > 0) {
      let setTimOutTimer: number = 0; // Variable to store timeout delay
      let marketInfoTab: string[] = ['gender', 'birthday']; // List of fields related to the market info tab
      // Check if the first word in the message matches a predefined field and set the tab index
      if (marketInfoTab?.some(value => value === space_serrated?.[0]?.trim())) {
        this.rightActiveIndex = 1; // Setting active tab index
        setTimOutTimer = 500; // Setting delay for scrolling
      }
      setTimeout(() => {
        const element = this.formElementRef.nativeElement.querySelector(`[formControlName="${space_serrated?.[0]?.trim()}"]`)
          ? this.formElementRef.nativeElement.querySelector(`[formControlName="${space_serrated?.[0]?.trim()}"]`)
          : this.formElementRef.nativeElement.querySelector(`[name="${space_serrated?.[0]?.trim()}"]`)
            ? this.formElementRef.nativeElement.querySelector(`[name="${space_serrated?.[0]?.trim()}"]`)
            : this.formElementRef.nativeElement.querySelector(`[id="${space_serrated?.[0]?.trim()}"]`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, setTimOutTimer);
    }
  }

  // ------------ Streams Pagination -------------------------------

  streamRows: number = 15;
  streamPage: number = 1;
  isLoading: boolean = true;
  streamScrollTop: number = 0;
  @ViewChild('streamScrollableElement') streamScrollableElement!: ElementRef;
  streamScrollToTop(): void {
    const element = this.streamScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onStreamScroll(event: Event): void {
    const element = event.target;
    this.streamScrollTop = element['scrollTop'];
    let a: any = element['scrollHeight'] - element['scrollTop'];
    let b: any = element['scrollHeight'] - element['scrollTop'];
    let c = element['clientHeight'];

    if ((parseInt(a) - 5 < parseInt(c) || parseInt(b) == parseInt(c)) && this.isLoading) {
      this.streamPage = this.streamPage + 1;
      this.isLoading = false;
      this.getStream(this.streamPage, 15, this.keyword, true);
    }
  }

  // ------------- SideBar Leads Pagination ------------------------------

  sideLeadRows: number = 10;
  sideLeadScrollTop: number = 0;
  @ViewChild('sideLeadScrollableElement') sideLeadScrollableElement!: ElementRef;
  sideLeadScrollToTop(): void {
    const element = this.sideLeadScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onSideLeadScroll(event: Event): void {
    const element = event.target;
    this.sideLeadScrollTop = element['scrollTop'];
  }

  // ------------- SideBar Task Pagination ------------------------------

  sideTaskRows: number = 10;
  sideTaskScrollTop: number = 0;
  @ViewChild('sideTaskScrollableElement') sideTaskScrollableElement!: ElementRef;
  sideTaskScrollToTop(): void {
    const element = this.sideTaskScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onSideTaskScroll(event: Event): void {
    const element = event.target;
    this.sideTaskScrollTop = element['scrollTop'];
  }

  // ------------- SideBar Listing Pagination ------------------------------

  sideListingRows: number = 10;
  sideListingScrollTop: number = 0;
  @ViewChild('sideListingScrollableElement') sideListingScrollableElement!: ElementRef;
  sideListingScrollToTop(): void {
    const element = this.sideListingScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onSideListingScroll(event: Event): void {
    const element = event.target;
    this.sideListingScrollTop = element['scrollTop'];
  }

  // ------------- SideBar Property Pagination ------------------------------

  sidePropertyRows: number = 10;
  sidePropertyScrollTop: number = 0;
  @ViewChild('sidePropertyScrollableElement') sidePropertyScrollableElement!: ElementRef;
  sidePropertyScrollToTop(): void {
    const element = this.sidePropertyScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onSidePropertyScroll(event: Event): void {
    const element = event.target;
    this.sidePropertyScrollTop = element['scrollTop'];
  }

  // ------------- SideBar Project Pagination ------------------------------

  sideProjectRows: number = 10;
  sideProjectScrollTop: number = 0;
  @ViewChild('sideProjectScrollableElement') sideProjectScrollableElement!: ElementRef;
  sideProjectScrollToTop(): void {
    const element = this.sideProjectScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onSideProjectScroll(event: Event): void {
    const element = event.target;
    this.sideProjectScrollTop = element['scrollTop'];
  }

  // ------------- SideBar Contract Pagination ------------------------------

  sideContractRows: number = 10;
  sideContractScrollTop: number = 0;
  @ViewChild('sideContractScrollableElement') sideContractScrollableElement!: ElementRef;
  sideContractScrollToTop(): void {
    const element = this.sideContractScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onSideContractScroll(event: Event): void {
    const element = event.target;
    this.sideContractScrollTop = element['scrollTop'];
  }

  // ------------- SideBar Related Contacts Pagination ------------------------------

  sideRelatedContactRows: number = 10;
  relatedContactScrollTop: number = 0;
  @ViewChild('relatedContactScrollableElement') relatedContactScrollableElement!: ElementRef;
  relatedContactScrollToTop(): void {
    const element = this.relatedContactScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onRelatedContactScroll(event: Event): void {
    const element = event.target;
    this.relatedContactScrollTop = element['scrollTop'];
  }

  scrollTop: number = 0;
  previousScrollTop = 0;
  page: number = 1;
  total_contact: any;
  @ViewChild('scrollableElement') scrollableElement!: ElementRef;
  scrollToTop(): void {
    const element = this.scrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onScroll(event: Event): void {
    const element = event.target as HTMLElement;
    this.scrollTop = element.scrollTop;
  }

  tabs = tabsConfig;
  selectedItem = tabsConfig[this.rightActiveIndex];
  isTabVisible(tab: any): boolean {
    if (!tab.conditions.length) return true;
    return tab.conditions.every((condition: any) => condition(this.userRole, this.userPermission));
  }

  selectItem(item: any): void {
    this.selectedItem = item;
    this.rightActiveIndex = item.panel;
    this.showMenu = false;
    this.onChangeRightPanel(item.label);
  }

  getBadgeCount(tab: any): number {
    return tab.badge ? tab.badge({ ...this }) : null;
  }

  toggleBox(box): void {
    box.isOpen = !box.isOpen;
  }

  types_by_module = [];
  contactListingType: any[] = [];
  getTags(isCache = false) {
    // this.loadTag = false
    this.contactType = [];
    this.contactListingType = [];
    this.preferred_contact_method = [];
    this.companyType = [];
    this.companyRole = [];
    this.addTile = [];
    // this.contactRelatedTag = [];
    this.redux.getTags(this.api.getOfficeId(), isCache, 'contact').subscribe({
      next: res => {
        this.isCache = true;
        const { data } = res;
        let res_data = JSON.parse(JSON.stringify(data))?.map(ele => {
          return {
            ...ele,
            types: ele?.types?.map(el => {
              return (el = { ...el, isOpen: true });
            }),
          };
        });
        this.tagsData = JSON.parse(JSON.stringify(res_data));
        console.log('tag >>:', this.tagsData);
        this.contact_tag_module_id = res_data[0]?._id;
        this.tagsDataCopy = JSON.parse(JSON.stringify(res_data));
        this.tagsData.forEach(element => {
          this.types_by_module = element?.types?.map(el => {
            return (el = { ...el, isOpen: true });
          });
          this.types_by_module.forEach(tag => {
            if (tag?.slug === 'contact-type') {
              this.contactType = tag?.data?.sort((a, b) => a?.tag_name.localeCompare(b?.tag_name));
            }
            if (tag?.slug === 'contact-listing-type') {
              this.contactListingType = tag?.data?.sort((a, b) => a?.tag_name.localeCompare(b?.tag_name));
            }
            if (tag?.slug === 'preferred-contact-method') {
              this.preferred_contact_method = tag?.data?.sort((a, b) => a?.tag_name.localeCompare(b?.tag_name));
            }
            if (tag?.slug === 'company-contact-type') {
              this.companyType = tag?.data?.sort((a, b) => a?.tag_name.localeCompare(b?.tag_name));
            }
            if (tag?.slug === 'company-role') {
              this.companyRole = tag?.data?.sort((a, b) => a?.tag_name.localeCompare(b?.tag_name));
            }
            if (tag?.slug === 'title') {
              this.addTile = tag?.data?.sort((a, b) => a?.tag_name.localeCompare(b?.tag_name));
            }
          });
        });

        let isExits = this.types_by_module.find(x => x?._id === 'createnew');
        if (!isExits) {
          this.types_by_module.push({ name: '+ Create New', _id: 'createnew' });
        }
      },
      error: error => {
        this.toastr.error(error?.message);
      },
    });
  }

  getListingTags(isCache = false) {
    this.redux.getTags(this.api.getOfficeId(), isCache, 'listing').subscribe({
      next: res => {
        this.isCache = true;
        let tagData = JSON.parse(JSON.stringify(res?.data));
        this.relatedContactTags = [];
        tagData.forEach(element => {
          this.types_by_module = element.types;
          this.types_by_module.forEach(tag => {
            if (tag?.slug == 'related-contact') {
              this.relatedContactTags = tag?.data.sort((a, b) => a?.tag_name.localeCompare(b?.tag_name));
            }
          });
        });
      },
      error: error => {
        this.toastr.error(error?.message);
      },
    });
  }

  onRContactSort(event: any): void {
    const sortField = event.field;
    const sortOrder = event.order;

    this.attached_contacts.sort((a: any, b: any) => {
      let valueA, valueB;

      if (sortField === 'relation') {
        // relation is directly on the root object, and is an array of strings
        valueA = (a['relation'] || [])[0] || '';
        valueB = (b['relation'] || [])[0] || '';
      } else if (sortField === 'company_name') {
        // companies is an array of strings inside contact
        valueA = (a.contact?.companies || []).join(', ');
        valueB = (b.contact?.companies || []).join(', ');
      } else {
        valueA = a.contact?.[sortField] || '';
        valueB = b.contact?.[sortField] || '';
      }

      // Basic string comparison
      let result = 0;
      if (valueA < valueB) result = -1;
      if (valueA > valueB) result = 1;

      return sortOrder * result;
    });
  }

  onCancelTagDialog() {
    this.module_type = null;
    this.new_tag = [];
    this.tag_type = null;
    this.new_tag_popup = false;

    // ✅ Clear internal input field
    const inputEl = this.chipsRef.nativeElement.querySelector('input');
    if (inputEl) inputEl.value = '';
  }
}
